module.exports = __webpack_public_path__ + "img/37.10.pH.ecad3e2c.png";